const ProgressBar = ({ progressPercentage }) => (
  <div className="h-2 w-full bg-gray-300 rounded overflow-hidden">
    <div style={{ width: `${progressPercentage}%` }} className="h-full bg-green-600" />
  </div>
);

export default ProgressBar;
